/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect} from 'react'
import GoogleZoom from './GoogleZoom'


const DvlaHistory = (props) => {
    // content to render
    const [ content, setContent ] = useState(null)
    const [ imgArray, setImgArray ] = useState([])

    // toggle gate
    const [ dvlaHistoryGate, setDvlaHistoryGate ] = useState(false)


    // handle the toggling
    const handleClick = () => {
        dvlaHistoryGate ? setDvlaHistoryGate(false) : setDvlaHistoryGate(true)
    }

    // handle toggling zoom screen
    const [ returnBool, setReturnBool ] = useState(false)

    // toggle the screen
    useEffect( () => {
        if (dvlaHistoryGate) {
            setContent(
                <div className='historyFullScreen'>
                    <div className='listsContainerDvla'>
                        <div className='imageDvlaContainer'>
                            {imgArray}
                        </div>
                        <div 
                            className='viewDriverHistoryTwo'
                            onClick={handleClick}
                        >
                            Return
                        </div>
                    </div>
                </div>
            )
        }
        else {
            setContent(
                <div 
                    className='viewDriverHistory'
                    onClick={handleClick}
                >
                    DVLA History
                </div>
            )
        }

    }, [dvlaHistoryGate, imgArray, returnBool])

    const handleReturn = () => {
        setContent(null)
        returnBool ? setReturnBool(false) : setReturnBool(true)
    }

    const handleAllowZoom = (e, theImage) => {
        console.log(theImage)
        if (theImage.imagesLink) {
            setContent(
                <div className='makeZoomPossible'>
                    <div className='innerZoom'>
                        <GoogleZoom img={theImage.imagesLink} />
                    </div>
                    <button className='returnButton' onClick={handleReturn}>Return</button>
                </div>
            )
        } else {
            setContent(
                <div className='makeZoomPossible'>
                    <div className='innerZoom'>
                        <GoogleZoom img={theImage} />
                    </div>
                    <button className='returnButton' onClick={handleReturn}>Return</button>
                </div>
            )
        }
    }

    // map the props
    useEffect( () => {
        let localImgArray = []
        if (props.selectedDriver) {
            props.selectedDriver.imgArray.forEach( image => {
                if (image.name === 'DVLA Check') {
                    if (image.imagesLink.includes('.pdf')) {
                        let pngUrlPdf = image.imagesLink.replace(/.pdf/, '.png')
                        localImgArray.push(
                            <div className='borderBoxContainer' onClick={(e, image) => handleAllowZoom(e, pngUrlPdf)}>
                                <div>
                                    <img src={pngUrlPdf} alt="DVLA Alt" className='miniDvlaHistory'/>
                                </div>
                            </div>
                        )
                    } else {
                        localImgArray.push(
                            <div className='borderBoxContainer' onClick={(e, theimage) => handleAllowZoom(e, image)}>
                                <div>
                                    <img src={image.imagesLink} alt="DVLA Alt" className='miniDvlaHistory'/>
                                </div>
                            </div>
                        )
                    }
                }
            })
        }
        setImgArray(localImgArray)
    }, [props])

    return (
        <>
            {content}
        </>
    )
}

export default DvlaHistory